import { getABNVariant } from '~/src/helpers/abn-tests';

const isOnlyPurchaseEquipment = () => {
    return getABNVariant('hiding_payment_installments') === 'hide_installment_plan';
};

export default isOnlyPurchaseEquipment;
